var _path, _path2, _path3, _path4, _path5, _path6, _mask, _g, _mask2, _g2, _path7, _path8, _path9, _mask3, _g3, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPicMessageEmpty(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 358.001,
    height: 264.333,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M353.068 78.846l-51.733.089a3.436 3.436 0 01-3.441-3.433l-.037-27.11c-.003-1.898 1.534-3.528 3.432-3.53h51.733a3.435 3.435 0 013.441 3.432l.038 27.11a3.438 3.438 0 01-3.433 3.442z",
    fillRule: "evenodd",
    fill: "#FFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M301.335 78.935a3.436 3.436 0 01-3.441-3.433l-.037-27.11c-.003-1.898 1.534-3.528 3.432-3.53h51.733a3.435 3.435 0 013.441 3.432l.038 27.11a3.438 3.438 0 01-3.433 3.442l-51.733.089z",
    stroke: "#000",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M313.941 61.914l20.634.08",
    stroke: "#E4E4E4",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56.71 163.489l-51.732.089a3.436 3.436 0 01-3.442-3.432l-.036-27.11c-.003-1.899 1.533-3.529 3.432-3.531h51.733a3.436 3.436 0 013.44 3.433l.039 27.109a3.438 3.438 0 01-3.433 3.442z",
    fillRule: "evenodd",
    fill: "#FFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.978 163.578a3.436 3.436 0 01-3.442-3.432l-.036-27.11c-.003-1.899 1.533-3.529 3.432-3.531h51.733a3.436 3.436 0 013.44 3.433l.039 27.109a3.438 3.438 0 01-3.433 3.442l-51.733.089z",
    stroke: "#000",
    strokeWidth: 3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.978 163.578a3.436 3.436 0 01-3.442-3.432l-.036-27.11c-.003-1.899 1.533-3.529 3.432-3.531h51.733a3.436 3.436 0 013.44 3.433l.039 27.109a3.438 3.438 0 01-3.433 3.442l-51.733.089z",
    stroke: "#000",
    strokeWidth: 3
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "pic-message-empty_svg__a",
    maskUnits: "userSpaceOnUse",
    x: 109.596,
    y: 255.001,
    width: 179.95,
    height: 9.331
  }, /*#__PURE__*/React.createElement("path", {
    d: "M109.596 255.001h179.95v9.332h-179.95v-9.332z",
    fillRule: "evenodd",
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#pic-message-empty_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M289.546 259.667c0 2.576-72.469 4.666-104.737 4.666-32.271 0-75.213-2.09-75.213-4.666 0-2.576 42.942-4.666 75.213-4.666 32.268 0 104.737 2.09 104.737 4.666z",
    fillRule: "evenodd",
    fill: "#E4E4E4"
  }))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "pic-message-empty_svg__b",
    maskUnits: "userSpaceOnUse",
    x: 177.921,
    y: 0,
    width: 27.437,
    height: 22.866
  }, /*#__PURE__*/React.createElement("path", {
    d: "M177.921 0h27.436v22.866h-27.436V0z",
    fillRule: "evenodd",
    fill: "#C4C4C4"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#pic-message-empty_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M178.062 22.866l-.139-8.992C177.805 6.33 183.826.118 191.371.002c7.545-.118 13.757 5.905 13.873 13.45l.113 7.33-27.295 2.085z",
    fillRule: "evenodd",
    fill: "#000"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M125.447 147.912c-3.885 14.045-8.997 27.237-15.731 37.156M282.457 179.354c-20.515-24.248-28.95-75.542-31.641-96.604-.601-4.705-.758-9.429-.897-14.17-.698-24.024-22.834-44.741-51.806-47.384-29.935-2.73-56.187 14.84-59.958 39.602",
    stroke: "#000",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M286.995 182.588c.357 13.409-39.867 25.356-89.843 26.685-49.974 1.329-90.776-8.463-91.133-21.874-.357-13.408 39.868-25.355 89.842-26.684 49.976-1.329 90.778 8.465 91.134 21.873z",
    fillRule: "evenodd",
    fill: "#000"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M92.176 120.213s9.466 8.236 25.019 9.358l9.045.227c4.478.112 12.286-1.377 17.655-2.511 9.83-2.078 19.926-6.986 25.964-10.183 12.909-6.833 33.264-20.99 33.264-20.99",
    stroke: "#000",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "pic-message-empty_svg__c",
    maskUnits: "userSpaceOnUse",
    x: 105.994,
    y: 160.594,
    width: 180.98,
    height: 48.799
  }, /*#__PURE__*/React.createElement("path", {
    d: "M195.839 160.715c-49.975 1.329-90.199 13.275-89.843 26.685.358 13.409 41.159 23.201 91.134 21.872 49.974-1.328 90.199-13.274 89.843-26.684-.335-12.591-36.33-21.995-82.099-21.994-2.972 0-5.987.04-9.035.121z",
    fillRule: "evenodd",
    fill: "#C4C4C4"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#pic-message-empty_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M214.214 168.692c-.967 10.604-10.348 18.417-20.952 17.45-10.606-.967-18.418-10.349-17.45-20.954.966-10.604 10.348-18.417 20.952-17.449 10.604.967 18.417 10.348 17.45 20.953z",
    fillRule: "evenodd",
    fill: "#ac1e1e"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M68.473 65.064h33.126M40.036 65.064h13.33M116.835 88.223c2.402-7.055 9.725-11.834 17.878-10.25 6.075 1.18 10.971 6.076 12.15 12.151 1.939 9.976-5.649 18.707-15.276 18.707h-7.314c-3.168 0-6.335-.291-9.429-.976-6.502-1.439-16.924-4.963-26.276-13.525",
    stroke: "#000",
    strokeWidth: 4,
    strokeLinecap: "round"
  })));
}
export default SvgPicMessageEmpty;